import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../apiConfig';
import moment from 'moment';

const createQueryParams = (page, pageSize, filters) => {
  const params = new URLSearchParams();
  
  if (page) params.append('page', page);
  if (pageSize) params.append('page_size', pageSize);
  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });
  }

  return params.toString();
};


export const fetchDueOxyzo = createAsyncThunk(
  'due/fetchDueOxyzo',
  async ({ jwtBearer, page, pageSize, filters } = {}, { rejectWithValue }) => {
    try {
      const queryParams = createQueryParams(page, pageSize, filters);
      const response = await axios.get(
        `${BASE_URL}oxyzo/due/data/${queryParams ? `?${queryParams}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.reload();
      }
      console.error('Fetch error:', error);
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);


export const fetchFilteredDueOxyzo = createAsyncThunk(
  'due/fetchFilteredDueOxyzo',
  async ({ jwtBearer, filters } = {}) => {
    const queryParams = createQueryParams(null, null, filters);
    const response = await axios.get(`${BASE_URL}oxyzo/due/data/${queryParams ? `?${queryParams}` : ''}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    });
    return response.data;
  }
);


const dueOxyzoSlice = createSlice({
  name: 'oxyzoDue',
  initialState: {
    data: [],
    loading: false,
    error: null,
    totalCount: 0,

    filteredData: [],
    filteredLoading: false,
    filteredError: null,
    filteredTotalCount: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDueOxyzo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDueOxyzo.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.due_data; 
        console.log("state.data--",state.data)
        state.totalCount = action.payload.data.total_due_data; 
      })
      .addCase(fetchDueOxyzo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchFilteredDueOxyzo.pending, (state) => {
        state.filteredLoading = true;
        state.filteredError = null;
      })
      .addCase(fetchFilteredDueOxyzo.fulfilled, (state, action) => {
        state.filteredLoading = false;
        state.filteredData = action.payload.data.due_data;
        state.filteredTotalCount = action.payload.data.total_due_data || 0; 
      })
      .addCase(fetchFilteredDueOxyzo.rejected, (state, action) => {
        state.filteredLoading = false;
        state.filteredError = action.error.message;
      });
  }
});

export default dueOxyzoSlice.reducer;
